import type { ReactNode } from 'react';

export const symbol_health_and_beauty: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M681-80q-12 0-21-9t-9-21q0-12 9-21t21-9h145v-104H681q-12 0-21-9t-9-21q0-12 9-21t21-9h145v-104H681q-12 0-21-9t-9-21q0-12 9-21t21-9h145v-104H681q-12 0-21-9t-9-21q0-12 9-21t21-9h145v-104H681q-12 0-21-9t-9-21q0-12 9-21t21-9h166q31 0 52 21t21 52v570q0 31-21 52t-52 21H681Zm-440.8-60H376l125-345-147-86h-92l-147 86 125.2 345ZM308-356ZM183-120 57-465q-8-20-.66-40.35T83-537l163-96v-216q0-12.75 8.63-21.38Q263.25-879 276-879h63.51q13.49 0 21.99 8.62 8.5 8.63 8.5 21.38v216l163 96q19.32 11.3 26.66 31.65Q567-485 559-465L433-120q-7 18-21.99 29-15 11-34.01 11H239q-19.01 0-34.01-11Q190-102 183-120Z"
		/>
	</svg>
);
